import { motion } from "framer-motion";

export function ScrollReveal({
  children,
  className = "",
  delay = 0,
  duration = 0.6,
  y = 30,
  staggerChildren = 0,
  scale = 1,
}) {
  if (staggerChildren > 0) {
    return (
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: staggerChildren,
              delayChildren: delay,
            },
          },
        }}
        className={className}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y, scale }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ScrollRevealItem({
  children,
  className = "",
  y = 25,
  scale = 1,
}) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y, scale },
        visible: { 
          opacity: 1, 
          y: 0, 
          scale: 1,
          transition: {
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }
        },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
